import { useEffect, useRef, useState } from "react";
import {
  ULTIMATE_AGENT_API_ERROR_EVENT,
  executeUltimateAgentCommand,
  getUltimateAgentApiMode,
  ULTIMATE_AGENT_API_MODE,
} from "./ultimateAgentClient";

const reportLiveQueryError = (command, error) => {
  if (typeof window === "undefined" || typeof window.CustomEvent !== "function") return;

  const commandName = typeof command === "string" ? command : command?.name;
  window.dispatchEvent(new window.CustomEvent(ULTIMATE_AGENT_API_ERROR_EVENT, {
    detail: {
      commandName,
      message: error?.message || "The backend request could not be completed.",
      statusCode: error?.statusCode || error?.response?.status,
      contractIssues: error?.contractIssues || [],
    },
  }));
};

export const useUltimateAgentQuery = (command, payload, mock, options = {}) => {
  const apiMode = options.mode || getUltimateAgentApiMode();
  const initialData = apiMode === ULTIMATE_AGENT_API_MODE.MOCK
    ? options.initialData
    : options.liveInitialData;
  const [state, setState] = useState({ data: initialData, loading: true, error: null, mode: apiMode });
  const mounted = useRef(true);
  const payloadKey = JSON.stringify(payload || {});

  useEffect(() => () => { mounted.current = false; }, []);

  useEffect(() => {
    if (options.enabled === false) {
      setState((previous) => ({ ...previous, loading: false, error: null }));
      return undefined;
    }
    let current = true;
    setState((previous) => ({ ...previous, loading: true, error: null }));
    executeUltimateAgentCommand(command, payload || {}, { mock, mode: apiMode })
      .then((result) => {
        if (current && mounted.current) setState({ data: result.data, loading: false, error: null, mode: result.mode });
      })
      .catch((error) => {
        if (current && mounted.current) {
          setState((previous) => ({ ...previous, loading: false, error }));
          if (apiMode === ULTIMATE_AGENT_API_MODE.LIVE) reportLiveQueryError(command, error);
        }
      });
    return () => { current = false; };
    // payloadKey is the stable request identity; callers should memoise mock handlers where needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiMode, command?.name || command, options.enabled, payloadKey]);

  return state;
};
